const utf8ToAnsiMap = {
  àáạảãâầấậẩẫăằắặẳẵ: 'a',
  èéẹẻẽêềếệểễ: 'e',
  ìíịỉĩ: 'i',
  òóọỏõôồốộổỗơờớợởỡ: 'o',
  ùúụủũưừứựửữ: 'u',
  ỳýỵỷỹ: 'y',
  đ: 'd',
  ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴ: 'A',
  ÈÉẸẺẼÊỀẾỆỂỄ: 'E',
  ÌÍỊỈĨ: 'I',
  ÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠ: 'O',
  ÙÚỤỦŨƯỪỨỰỬỮ: 'U',
  ỲÝỴỶỸ: 'Y',
  Đ: 'D',
}

export function utf8ToAnsi(txt = '') {
  if (!txt) return ''
  for (const [key, value] of Object.entries(utf8ToAnsiMap)) {
    txt = txt.replace(new RegExp(`[${key}]`, 'g'), value)
  }
  txt = txt.replace(/\u0300|\u0301|\u0303|\u0309|\u0323|\u02C6|\u0306|\u031B/g, '') // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  // txt = txt.replace(/\u02C6|\u0306|\u031B/g, '') // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  txt = txt.replace(/ + /g, ' ') // Remove extra spaces
  txt = txt.trim()
  // Remove punctuations

  /*str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    ' '
  ) // Remove punctuations*/
  return txt
}
